import { useVideoConfig, OffthreadVideo, Audio } from "remotion";
import { VideoSegmentMultiFocusDesignSystemConfig } from "../../VideoSegmentMultiFocus";
import { BorderWrapper } from "../utils/borderStyle";
import { getCloudFrontUrl } from "../../../../../../helper/CloudFrontUrlHelper";

export const DefaultFocusVideoSegment: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = ({ 
    startTimestampMS, 
    endTimestampMS, 
    videoURL, 
    spacing: padding, 
    borderRadius, 
    border, 
    borderStyle,
    audioURL 
}) => {
    const { width, height, fps } = useVideoConfig();
    const resolvedVideoURL = getCloudFrontUrl(videoURL);
    const resolvedAudioURL = audioURL ? getCloudFrontUrl(audioURL) : undefined;

    const paddingSize = padding ? Math.sqrt(width * height) * 0.05 : 0;
    const borderThickness = border ? Math.sqrt(width * height) / 150 : 0;

    console.log(audioURL);
    return (
        <div style={{ margin: paddingSize }}>
            <BorderWrapper 
                borderStyle={borderStyle}
                borderThickness={borderThickness}
                borderRadius={borderRadius}
            >
                <OffthreadVideo
                    src={resolvedVideoURL}
                    startFrom={startTimestampMS / 1000 * fps}
                    endAt={endTimestampMS / 1000 * fps}
                    style={{
                        objectFit: 'scale-down',
                        transformOrigin: 'center center',
                    }}
                    muted={Boolean(resolvedAudioURL)}
                />
                {resolvedAudioURL && <Audio src={resolvedAudioURL} />}
            </BorderWrapper>
        </div>
    )
}
